import {get as _get} from "lodash";
import store from "@/store";


export default {
    beforeRouteEnter() {
        let continueUrl =  _get(store.state, 'context.continueUrl');
        let loginUrl = process.env.VUE_APP_NEST_URL + '/login';
        if (continueUrl) {
            loginUrl += '?continue=' + continueUrl;
        }
        window.location.replace(loginUrl);
    }
}

